export default "__VITE_ASSET__Bj4wL3DH__"